import { Component, HostBinding, Input } from '@angular/core';
import { TableColumnConfiguration } from '..';

@Component({
  selector: 'th[avanoTableColumnHeader]',
  templateUrl: './avano-table-column-header.component.html',
  styleUrls: ['./avano-table-column-header.component.scss'],
})
export class AvanoTableColumnHeaderComponent {
  @Input('avanoTableColumnHeader') displayColumn: TableColumnConfiguration

  @HostBinding('class') hostStyleClass ='avano-table-column-header';
}
